import type { Nullable } from '@src/shared/types/common';

import { getLocaleKeyByCode, localizableKeys } from '../utils/localizable-string';

function getLocalizationViewFrameId(controlName: string, localeKey: LocalizableKey): string {
    return `${controlName}ViewFrame_${localeKey}`;
}

function applyDescriptionFrameHtmlSettings(contentHtml: JQuery): void {
    contentHtml.css({
        'font-family': 'Arial',
        'font-size': '12px'
    });
}

function refreshDescriptionFrame(frameId: string, html: string): void {
    const $frame = $(`#${frameId}`);

    if (!$frame.length) {
        return;
    }

    const contentHtml = $frame.contents().find('html');

    contentHtml.html(`<base target="_parent">${html}`);
    applyDescriptionFrameHtmlSettings(contentHtml);
    requestAnimationFrame(() => $frame.height(contentHtml.height() ?? 0));
}

function refreshDescriptionViewFrames(
    controlName: string,
    value: Nullable<PartialLocalizableString | undefined>,
    locales: readonly LocalizableKey[] = localizableKeys
): void {
    locales.forEach((locale) => {
        refreshDescriptionFrame(getLocalizationViewFrameId(controlName, locale), value?.[locale] ?? '');
    });
}

function applyDescriptionEditorsHtmlSettings(
    controlName: string,
    locales: readonly LocalizableKey[] = localizableKeys
): void {
    locales.forEach((locale) => {
        const editor = $(`#${controlName}_${locale}`).getKendoEditor();
        const ownerDocument = editor?.body.ownerDocument;

        if (!editor || !ownerDocument) {
            return;
        }

        applyDescriptionFrameHtmlSettings($(ownerDocument.documentElement));
        ownerDocument.documentElement.style.height = 'auto';
        editor.body.style.marginLeft = '0';
    });
}

function refreshKendoEditors(controlName: string, locales: readonly LocalizableKey[] = localizableKeys): void {
    locales.forEach((locale) => {
        const editor = $(`#${controlName}_${locale}`).getKendoEditor();

        if (!editor) {
            return;
        }

        editor.refresh();
        applyDescriptionEditorsHtmlSettings(controlName, [locale]);
    });
}

function getActiveLocalizationLocaleKey(controlName: string): LocalizableKey {
    const tabStrip = $(`#${controlName}_tsLocales`).data('kendoTabStrip');
    const localeCode = tabStrip?.select().attr('data-locale');

    return getLocaleKeyByCode(localeCode) ?? localizableKeys[0];
}

function refreshActiveKendoEditors(controlName: string): void {
    refreshKendoEditors(controlName, [getActiveLocalizationLocaleKey(controlName)]);
}

function localizationLocalesTabStrip_onSelect(e: kendo.ui.TabStripSelectEvent): void {
    const $root = e.sender.element.closest('.localization-field');
    const controlName = $root.attr('data-control-name');
    const localeKey = getLocaleKeyByCode(e.item?.getAttribute('data-locale'));

    if (!controlName || !localeKey) {
        return;
    }

    if ($root.find('.ticket-param:visible').length > 0) {
        refreshKendoEditors(controlName, [localeKey]);
        return;
    }

    const $viewFrame = e.contentElement ? $(e.contentElement).find(`#${getLocalizationViewFrameId(controlName, localeKey)}`) : $();

    if (!$viewFrame.length) {
        refreshKendoEditors(controlName, [localeKey]);
        return;
    }

    requestAnimationFrame(() => {
        const contentHtml = $viewFrame.contents().find('html');
        $viewFrame.height(contentHtml.height() ?? 0);
    });
}

window.localizationLocalesTabStrip_onSelect = localizationLocalesTabStrip_onSelect;
window.applyDescriptionEditorsHtmlSettings = applyDescriptionEditorsHtmlSettings;
window.refreshDescriptionViewFrames = refreshDescriptionViewFrames;
window.refreshActiveKendoEditors = refreshActiveKendoEditors;
